import { render } from "./TheApp.vue?vue&type=template&id=694cb386&scoped=true"
import script from "./TheApp.vue?vue&type=script&lang=js"
export * from "./TheApp.vue?vue&type=script&lang=js"

import "./TheApp.vue?vue&type=style&index=0&id=694cb386&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-694cb386"]])

export default __exports__